import _ from 'lodash';
import * as types from '../../constants/actionTypes';
import {firebase} from '../../firebase'

function requestTasks() {
  return {
    type: types.REQUEST_TASKS
  }
}

export function createTask(task) {
  return dispatch => {
    dispatch(requestTasks());
    const uid = firebase.auth().currentUser.uid;
    const newTaskKey = firebase.database().ref().child('tasks').push().key;
    let updates = {};
    let t = _.clone(task);
    t['projectLabel'] = null;
    t['projectColor'] = null;
    updates[`/tasks/${newTaskKey}`] = t;
    updates[`/user-tasks/${uid}/tasks/${newTaskKey}`] = task;
    return firebase.database().ref().update(updates);
  }
}

export function updateTask(taskKey, newData) {
  return dispatch => {
    dispatch(requestTasks());

    const user = firebase.auth().currentUser;
    let updates = {};
    updates[`tasks/${taskKey}/name`] = newData.name;
    updates[`tasks/${taskKey}/hours`] = newData.hours;
    updates[`tasks/${taskKey}/startAt`] = newData.startAt;
    updates[`tasks/${taskKey}/endAt`] = newData.endAt;
    updates[`user-tasks/${user.uid}/tasks/${taskKey}/name`] = newData.name;
    updates[`user-tasks/${user.uid}/tasks/${taskKey}/hours`] = newData.hours;
    //updates[`user-tasks/${user.uid}/tasks/${taskKey}/project`] = newData.project;
    //updates[`user-tasks/${user.uid}/tasks/${taskKey}/projectLabel`] = newData.projectLabel;
    updates[`user-tasks/${user.uid}/tasks/${taskKey}/startAt`] = newData.startAt;
    updates[`user-tasks/${user.uid}/tasks/${taskKey}/endAt`] = newData.endAt;
    return firebase.database().ref().update(updates);
  }
}

export function deleteTask(taskKey) {
  return dispatch => {
    dispatch(requestTasks());

    const user = firebase.auth().currentUser;
    let updates = {};
    updates[`tasks/${taskKey}`] = null;
    updates[`user-tasks/${user.uid}/tasks/${taskKey}`] = null;
    return firebase.database().ref().update(updates);
  }
}



/** WEBPACK FOOTER **
 ** ./src/actions/task/index.js
 **/